/* prettier-ignore */

import { Component, computed, HostListener, inject, signal, ViewEncapsulation } from "@angular/core";
import { ToolsService } from "./services/tools.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NavigationService } from "./services/navigation.service";
import { RestService } from "./services/rest.service";
import { AuthService } from "./services/auth.service";
import { ModalController } from "@ionic/angular";
import { UserService } from "./services/user.service";
import { StatisticsService } from "./services/statistics.service";
import { GoogleTranslateService } from "./services/google-translate.service";
import { fadeInAnimation } from './route-animations';
import { CookieService } from "ngx-cookie-service";
import { DebugService } from "./services/debug.service";
import { ChatBotScriptService } from "./services/chatbot.service";
import { TranslationService } from "./services/translation.service";
import { CurrentLanguage } from "./services";
import { WebsocketLaravelReverb } from "./fitur-26/pages/home/services";
import { CHANNEL_START_ROUTE_NAME, START_ROUTE_EVENT } from "./fitur-26/pages/home/config";
import { FiturDevPanelComponent } from "./fitur-26/pages/dev-panel/fitur-dev-panel.component";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [ fadeInAnimation ] 
})

export class AppComponent {
  private modalController = inject(ModalController);
  private debugService = inject(DebugService);
  private _router = inject(Router);
  private _translationService = inject(TranslationService);
  private _currentLanguageService = inject(CurrentLanguage);
  private _websocketLaravelReverbService = inject(WebsocketLaravelReverb);
  
  public isRegisterMode = computed(() => this.tools.isRegisterMode())
  public isAppLoaded = computed(() => this.tools.isAppLoaded());
  public isTechMode = computed(() => this.tools.isTechMode());

  private devPanelShow = signal(false);

  fiturModal: any;
  queryParamLang: any;
  chatId: any;

  @HostListener('window:keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      this.openFiturModal();
    }
  }

  constructor(
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public tools: ToolsService,
    public rest: RestService,
    public navigation: NavigationService,
    public authService: AuthService,
    public userService: UserService,
    public statsService: StatisticsService,
    public googleTranslateService: GoogleTranslateService,
    private cookieService: CookieService,
    private chatService: ChatBotScriptService,
  ) {
      this.rest.subDomain = 'madrid'; // !Harcoded for fitur  // this.tools.getSubdomain(window.location.href);
      this.debugService.info(this.rest.subDomain, '[AppComponent] SUBDOMAIN');
      
      this.tools.setCorporiveColors();
      
      this._websocketLaravelReverbService.connect();
      this._subscribeToChannelStartRoute();
  }

  ngOnInit(): void {
    if (this.rest.subDomain) {
      // COMMON APP REQUEST
      this.rest.getCommonApp(this.statsService.token).subscribe((response) => {
        this.debugService.debug(response, '[AppComponent] Common API Response');

        if (response.error) {
          this._router.navigateByUrl("not-found");
          return;
        }

        this.rest.setDevice(response);
        this.debugService.debug(this.rest.device, '[AppComponent] Device Info');
        this.enableChat(response);
      });
    } 
  }
  
  private _subscribeToChannelStartRoute(): void {
    this._websocketLaravelReverbService
      .subscribeToChannel(CHANNEL_START_ROUTE_NAME, START_ROUTE_EVENT)
    .subscribe({
      next: (data: any) => {
        console.log('Evento recibido:', data);
        const token = data.token;
        if (!token) return;

        this._router.navigate(['/home/route', token]);
      },
      error: (err: any) => console.error('Error en canal:', err)
    });
  }

  setLang(reponse: any) { // TODO: TYPE ACCORDING TO NEW ENDPOINT
    const lang = reponse.lang; // ? check
    if (!lang) return; 
  
    this._currentLanguageService.setLanguage(lang);
    this._translationService.setTranslateService(lang);
    this._translationService.selectedLanguage.set(lang);
  }

  enableChat(response){
    this.rest.device.chatBotId = response?.lang?.chatbot;
    this.rest.device.chatBotStandalone = response?.newVersion === 1;
    const mainLang = this.rest.device.mainLanguage ? this.rest.device.mainLanguage : "es";
    const newChat =  this.cookieService.get('newChat');
    if (this.rest.device.chatBotId && (this.rest.device.chatBotStandalone || newChat === 'true')){
      this.chatId = this.rest.device.chatBotId;
      this.chatService.chatId.set(this.chatId);
      return;
    }
   this.chatService.loadChat(mainLang);
  }

  async openFiturModal() {
    if (this.devPanelShow()){
      this.fiturModal.dismiss();
      return;
    }

    this.devPanelShow.set(true);
    this.fiturModal = await this.modalController.create({
        component: FiturDevPanelComponent,
        cssClass: ['devPanelModal', 'ion-disable-focus-trap'],
    });
    await this.fiturModal.present();
    await this.fiturModal.onDidDismiss();
    this.devPanelShow.set(false);
}
}